export function getCheckoutStatusLabel(status?: string): string {
  const labels: Record<string, string> = {
    pending: 'در انتظار بررسی',
    completed: 'تکمیل شده',
    failed: 'ناموفق',
  };
  return labels[(status || '').toLowerCase()] || status || '-';
}

export function getCheckoutStatusClass(status?: string): string {
  const normalized = (status || '').toLowerCase();
  return ['pending', 'completed', 'failed'].includes(normalized) ? normalized : '';
}
